import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { ContentActionsService } from '~commonInfra/contentActions/ContentActions';

import { requestFailed } from '../../../app/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { WhoHasSeenThisViewAction } from '../../actions/WhoHasSeenThisViewAction';

export function* handleWhoHasSeenThisViewAction(action: WhoHasSeenThisViewAction): SagaIterator {
  try {
    yield call(openWhoHasSeenThisViewDialog, action.view.id);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openWhoHasSeenThisViewDialog(viewId: string) {
  ContentActionsService.openWhoHasSeenThisView(viewId);
}
